export default __webpack_public_path__ + "static/media/loading.22b6bd8e.svg";